import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_SHOWROOMS,
  GET_SHOWROOM_DETAILS,
  CREATE_SHOWROOM,
  UPDATE_SHOWROOM,
  DELETE_SHOWROOM,
} from "./actionTypes"
import {
  getShowroomsFail,
  getShowroomsSuccess,
  getShowroomDetailsSuccess,
  getShowroomDetailsFail,
  createShowroomFail,
  createShowroomSuccess,
  updateShowroomSuccess,
  updateShowroomFail,
  deleteShowroomSuccess,
  deleteShowroomFail,
} from "./actions"

import { get, post, ApiPut, del } from "helpers/api_helper"
import { Notification } from "../../components/Common/Notification"

// Showroom - This line cannot be edited or removed
function getShowroomsAPi({ page, sort, limit, searchText }) {
  return get(
    `/showroom/admin/all/?page=${page ? page : 1}&limit=${
      limit ? limit : 10
    }&search=${searchText}`
  )
}

const getShowroomDetailsAPi = showroomId => {
  return get(`/showroom/admin/${showroomId}`)
}

const createShowroomApi = ({ showroom, onCloseClick }) => {
  return post("/showroom/admin/new", showroom, onCloseClick)
}

const updateShowroomApi = ({ showroom, showroomId, onCloseClick }) => {
  return ApiPut(`/showroom/admin/${showroomId}`, showroom, onCloseClick)
}

const deleteShowroomApi = ({ showroomId }) => {
  return del(`/showroom/admin/${showroomId}`)
}

function* fetchShowrooms({ payload }) {

  try {
    const response = yield call(getShowroomsAPi, payload)
    yield put(getShowroomsSuccess(response))
  } catch (error) {
    yield put(getShowroomsFail(error))
  }
}

function* fetchShowroomDetails({ payload: showroomId }) {
  try {
    const response = yield call(getShowroomDetailsAPi, showroomId)
    yield put(getShowroomDetailsSuccess(response))
  } catch (error) {
    yield put(getShowroomDetailsFail(error))
  }
}

function* onCreateShowroom({ payload }) {
  try {
    const response = yield call(createShowroomApi, payload)

    yield put(createShowroomSuccess(response))
    try {
      const response = yield call(getShowroomsAPi, payload)
      yield put(getShowroomsSuccess(response))
    } catch (error) {
      yield put(getShowroomsFail(error))
    }
    if (payload?.onCloseClick) {
      payload?.onCloseClick()
    }
    doneNotification("Showroom Created Successfully!")
  } catch (error) {
    if (error?.response?.data?.message) {
      Notification({
        type: "error",
        message: error?.response?.data?.message,
        title: "",
      })
    }
    if (error?.response?.status === 413) {
      Notification({
        type: "error",
        message: "file size is Too Large",
        title: "",
      })
    }
    yield put(createShowroomFail(error))
  }
}

export function* onUpdateShowroom({ payload }) {
  try {
    const response = yield call(updateShowroomApi, payload)

    if (response) {
      yield put(updateShowroomSuccess(response))

      Notification({
        type: "success",
        message: "Showroom Updated Successfully!",
        title: "",
      })

      // Refresh showroom list after update
      try {
        const listResponse = yield call(getShowroomsAPi)
        yield put(getShowroomsSuccess(listResponse))
      } catch (listError) {
        yield put(getShowroomsFail(listError))
      }

      // Call the modal close callback
      if (payload?.onCloseClick) {
        payload.onCloseClick()
      }
    }
  } catch (error) {
    console.error("Update Showroom Error:", error)

    const message =
      error?.response?.data?.message || error?.message || "Something went wrong"

    Notification({
      type: "error",
      message,
      title: "",
    })

    if (error?.response?.status === 413) {
      Notification({
        type: "error",
        message: "File size is too large",
        title: "",
      })
    }

    yield put(updateShowroomFail(error?.response?.data || { message }))
  }
}
function* onDeleteShowroom({ payload }) {
  try {
    const response = yield call(deleteShowroomApi, payload)
    yield put(deleteShowroomSuccess(response))
    try {
      const response = yield call(getShowroomsAPi, payload)
      yield put(getShowroomsSuccess(response))
    } catch (error) {
      yield put(getShowroomsFail(error))
    }
    doneNotification("Showroom Deleted Successfully!")
  } catch (error) {
    if (error?.response?.data?.message) {
      Notification({
        type: "error",
        message: error?.response?.data?.message,
        title: "",
      })
    }
    yield put(deleteShowroomFail(error?.response?.data))
  }
}

function* showroomSaga() {
  yield takeEvery(GET_SHOWROOMS, fetchShowrooms)
  yield takeEvery(GET_SHOWROOM_DETAILS, fetchShowroomDetails)
  yield takeEvery(CREATE_SHOWROOM, onCreateShowroom)
  yield takeEvery(UPDATE_SHOWROOM, onUpdateShowroom)
  yield takeEvery(DELETE_SHOWROOM, onDeleteShowroom)
}

export default showroomSaga

function doneNotification(message) {
  Notification({
    type: "success",
    message: message,
    title: "",
  })
}
